import { render, staticRenderFns } from "./accountReceivable.vue?vue&type=template&id=75978d62&scoped=true"
import script from "./accountReceivable.vue?vue&type=script&lang=js"
export * from "./accountReceivable.vue?vue&type=script&lang=js"
import style0 from "./accountReceivable.vue?vue&type=style&index=0&id=75978d62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75978d62",
  null
  
)

export default component.exports